import React, { PropsWithChildren } from "react";
import { styled } from "@mui/material/styles";
import { Icon, Zoom } from "@mui/material";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

export type TooltipsProps = {
	title: string | JSX.Element;
	icon: JSX.Element
};

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
	<Tooltip placement="top" TransitionComponent={Zoom} {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.arrow}`]: {
		color: "var(--clr-grey-1)",
	},
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: "var(--clr-grey-1)",
		color: "var(--clr-white);",
		fontSize: theme.typography.pxToRem(18), // Increase the font size to 18px
		padding: "10px",
		maxWidth: 300,
	},
}));

const InfoTooltip = (props: PropsWithChildren<TooltipsProps>) => {
	const { title, icon } = props;
	return (
		<BootstrapTooltip title={title} >
			{icon}
			{/* <Icon fontSize="inherit" >
				{icon}
			</Icon> */}
		</BootstrapTooltip>
	);
};

export default InfoTooltip;